import React from 'react';
import { renderToString } from 'react-dom/server';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import AutocompleteAddressItem from './AutocompleteAddressItem';

export const createGeocoder = (mapBoxAccessToken, placeHolder, locale) =>
  new MapboxGeocoder({
    accessToken: mapBoxAccessToken,
    minLength: 3,
    placeholder: placeHolder,
    limit: 7,
    language: locale,
    types: 'address',
    render: (item) =>
      // eslint-disable-next-line react/jsx-filename-extension
      renderToString(<AutocompleteAddressItem address={item.place_name} />),
  });

const buildAddressComponents = (context) => {
  const components = {};
  try {
    components.city =
      context.find((elem) => elem.id.startsWith('place'))?.text || '';
    const splittedRegion = context
      .find((elem) => elem.id.startsWith('region'))
      .short_code.split('-');
    const [country, region] = splittedRegion;
    components.country = country;
    components.stateOrProvince = region;
    components.postalCode = context.find((elem) =>
      elem.id.startsWith('postcode')
    ).text;
  } catch (error) {
    // Depending on the country, the address component names vary.
    // Above logic is validated with US addresses.
    // eslint-disable-next-line no-console
    console.warn('Error extracting address components', error);
  }

  return components;
};

export const buildAddress = (result) => {
  let addressLine1 = (result.address ? `${result.address} ` : '') + result.text;

  if (result.place_name.startsWith(result.text)) {
    addressLine1 = result.text + (result.address ? ` ${result.address}` : '');
  }

  return {
    addressLine1,
    ...buildAddressComponents(result.context),
  };
};
